import React from "react";
import { BsGoogle } from "react-icons/bs";
import { MdGroups } from "react-icons/md";
import img1 from '../../../assets/overview/rating.jpg'
import img2 from '../../../assets/overview/participant.jpg'
import img3 from '../../../assets/overview/noodcourse.jpg'
import { MdCastForEducation } from "react-icons/md";

import Card from "./Card";

let data = [
  {
    title: "Google Rating",
    value: "4.9/5",
    icon: img1,
  },
  {
    title: "Participants already benefitted",
    value: "1100",
    icon: img2,
  },
  {
    title: "Number of courses",
    value: "8",
    icon: img3,
  },
];

const HomePageMentors = () => {
  return (
    <section className="max-sm:px-5 ">
      <div className="max-w-7xl m-auto mt-16 relative ">
        <div className="flex justify-center m-auto mb-10 relative w-fit">
          <h1 className="text-[#2C3E50] text-2xl font-semibold max-sm:text-lg ">
            Overview
            {/* <img
              src={CapIcon}
              alt="icon"
              className="absolute -right-16 -top-14 "
            /> */}
          </h1>
        </div>
        <div className=" m-auto  max-w-5xl grid grid-cols-3 gap-6 max-sm:grid-cols-1 ">
          {data.map((item) => (
            <Card {...item} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomePageMentors;
